import { Button, Col, Form, Row } from 'antd';
import FilterSelectbox from 'components/Forms/DataGrid/FilterSelectbox';
import IFilterSelectOption from 'components/Forms/DataGrid/FilterSelectbox/IFilterSelectOption';
import FilterTextbox from 'components/Forms/DataGrid/FilterTextbox';
//import { TableFilterContext } from 'components/Forms/TableFilterContextProvider';
import { JoinType, TrackedBolStatus } from 'Core/Api/Kopp/Api';
import Utility from 'Core/Utility';
import { startCase } from 'lodash';
import * as React from 'react';
import TrackedBolHandler from '../TrackedBolHandler';
import { TrackedBolGenerateReportButton } from './TrackedBolGenerateReportButton';

export interface Props {
  children?: React.ReactNode;
}

export interface State {
  trackedBolStatuses?: IFilterSelectOption[];
}

export default class TrackedBolSearchBar extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.getStatus();
  }

  getStatus = () => {
    let statuses = Utility.enumToSelectionOptionArray(TrackedBolStatus);
    statuses = statuses.map(x => ({ text: startCase(x.text), value: x.value }));
    this.setState({ trackedBolStatuses: statuses });
  };

  render() {
    return (
      <Row>
        <Col span={21}>
          <Form layout="inline">
            <Form.Item label="Search Previously Submitted BL" labelAlign="left">
              <FilterTextbox
                style={{ width: 300 }}
                placeholder="Enter  BL #"
                filterFields="bolNumber"
              />
            </Form.Item>
            <Form.Item label="Status" labelAlign="left">
              <FilterSelectbox
                filterJoin={JoinType.And}
                options={this.state.trackedBolStatuses}
                style={{ width: 300 }}
                mode="multiple"
                placeholder="Select Status"
                filterFields="currentStatus"
              />
            </Form.Item>
          </Form>
        </Col>
        <Col span={3} pull={1}>
          <TrackedBolGenerateReportButton />
        </Col>
      </Row>
    );
  }
}
